import {Dimensions} from '../../types/commons';

export enum LaunchBarSize {
    EXPANDED,
    COLLAPSED,
    NORMAL
}

export enum WindowState {
    MINIMIZED,
    NORMAL
}

export type LaunchBarDimensions = Record<keyof typeof LaunchBarSize, Dimensions>;

export const LAUNCH_BAR_DIMENSIONS: LaunchBarDimensions = {
    NORMAL: {
        width: 604,
        height: 52
    },
    EXPANDED: {
        width: 604,
        height: 448
    },
    COLLAPSED: {
        width: 84,
        height: 52
    }
};
